export default {"src":"/_next/static/media/sphere-telegram-bot-profile-photo.63cf3ae2.svg","height":134,"width":134,"blurWidth":0,"blurHeight":0};